import React from 'react';
import Login from '../../../components/authentication/Login/Login';

const LoginPage = () => {
    return (
        <Login />
    );
};

export default LoginPage;
